export default "__VITE_ASSET__Bc61rONO__"